import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'blank',
    templateUrl: './blank.component.html',
    styleUrl: './blank.component.scss',
    host: {
        class: 'blank'
    },
    standalone: false
})
export class BlankComponent implements OnInit {
  async ngOnInit() { }
}
